// src/components/frontpage/columns/MoreButton.jsx
//
// The one "More"/"See all" control for ModeColumn's footer slot — replaces the byte-for-byte
// duplicated raw <button> that used to live in LocalityFrontPage.jsx and GroupFrontPage.jsx's
// News columns (docs/briefs/2026-08-13-more-control-phase-a.md §2, A1). One source, used
// wherever a column needs a "there's more, go see it" affordance: absent when there isn't,
// never greyed/disabled (§3; D8, docs/briefs/2026-08-13-expand-in-place-design-note-addendum-2.md).
// That rule is about "nothing more": the control is then absent, not greyed. `disabled` is a
// separate state — inert while a Load More request is already in flight (Roadmap #104, addendum 5),
// so a second press cannot send a second request. It is off by default; every existing caller is
// unchanged.
//
// Goes through StandardButton's existing showWhen="has-more" mechanism (StandardButton.jsx —
// confirmed live before this build used it) rather than a local isEmpty check, so "absent when
// nothing more exists" is the primitive's own guarantee, not something every caller re-derives.
//
// color should be passed explicitly by every caller — StandardButton's inline variant has no
// working default (its textColor token, tokens.colors.inlineText, points at a CSS custom
// property that's undefined repo-wide; see docs/reuse-backlog.md 2026-08-14). inlineTextColor
// was added to StandardButton.jsx alongside this component specifically to carry it.

import React from 'react';
import StandardButton from '../../core/StandardButton';

const MoreButton = ({ hasMore, onClick, label, color = null, iconName = 'ChevronRight', disabled = false }) => (
  <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '8px' }}>
    <StandardButton
      variant="inline"
      showWhen="has-more"
      hasMore={hasMore}
      onClick={onClick}
      label={label}
      iconName={iconName}
      inlineTextColor={color}
      disabled={disabled}
    />
  </div>
);

export default MoreButton;
